module.exports = __webpack_public_path__ + "img/success.348fa0f4.svg";